var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.componentClass},[(_vm.src&&_vm.showImage)?_c('image-base',_vm._g(_vm._b({attrs:{"src":_vm.src,"border-radius":"sm1"},on:{"error":_vm.error}},'image-base',_vm.$attrs,false),_vm.$listeners)):_c('icon-camera',{attrs:{"size":'sm4'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }